<template>
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb
              name="Payment Link"
              bc1="App"
              bc2="Attempts"
              bc3="Logs"
          ></Breadcrumb>
        </div>
        <div class="col-3">
          <div class="d-flex align-items-center justify-content-end">
            <button
                type="button"
                class="btn btn-gradient-danger btn-sm"
                @click="$router.back()"
            >
              <span class="text-nowrap">Back</span>
            </button>
          </div>
        </div>
        <div
            class="content-header-right text-md-right col-md-3 col-12 d-md-block d-none"
        >
        </div>
      </div>
      <div class="content-body">
        <div class="row">
          <div class="col-12">
            <div class="card card-user-timeline" v-if="attemptData && !isEmpty(attemptData)">
              <div class="card-header">
                <div class="d-flex align-items-center">
<!--                  <feather type="bar-chart" size="100" class="text-info mr-1 font-medium-1"></feather>-->
                  <img :src="`${publicPath}app-assets/images/icons/graph2.svg`" class="mr-1" style="max-height: 25px !important;">
                  <h4 class="card-title"> Payment# {{uuid}} </h4>
                </div>
              </div>
              <div class="card-body">
                <ul class="timeline ml-50 pb-4">
                  <li class="timeline-item">
                    <div class="timeline-event">
                      <div class="d-flex justify-content-between flex-sm-row flex-column mb-sm-0 mb-1">
                        <h6 class="text-primary font-weight-bolder">Step1: {{firstMsg}}</h6>
                        <span v-if="firstCreatedAt != ''" class="timeline-event-time mr-1">{{new Date(firstCreatedAt).toISOString().slice(0, 16).replace('T',' ')}}</span>
                      </div>
                      <div class="col-12">
                        <hr  />
                      </div>
                      <p><strong>IP Address:</strong> {{firstIp}}</p>
                      <p v-if="firstUuid"><strong>Transaction UUID:</strong> {{firstUuid}}</p>
                      <p v-if="firstPaymentToken"><strong>Payment Token:</strong> {{firstPaymentToken}}</p>
                      <div class="media align-items-center d-flex" v-if="!firstShow && firstData " >
                        <button type="button" class="btn btn-warning waves-effect waves-float waves-light btn-sm" @click="firstShow = true">Read more</button>
                      </div>
                      <div v-if="firstShow  && firstData && Object.keys(firstData).length != 0" class="row ">
                        <div class="col-md-6 col-6">
                          <div class="card border-warning badge-glow">
                            <div class="card-body">
                              <div class="row ">
                                <div class="col-12">
                                  <div v-for="(dataItem,dataIndex) in firstData" :key="dataIndex" class="form-group row">
                                    <div class="col-sm-3">
                                      <p class="text-dark font-weight-bolder">{{dataIndex}}</p>
                                    </div>
                                    <div class="col-sm-9">
                                      <div class="input-group">
                                        <p >{{dataItem}}</p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li class="timeline-item" v-for="(item,index) in logs" :key="index">
<!--                    <BIconCheckCircleFill  class="border-success badge-glow text-success timeline-point" />-->
                    <feather type="check-circle" class="border-success badge-glow text-success timeline-point"></feather>
                    <div class="timeline-event">
                      <div class="d-flex justify-content-between flex-sm-row flex-column mb-sm-0 mb-1">
                        <h6 class="text-primary font-weight-bolder">{{'Step '+parseInt(index+2)+' '+item.message}}</h6>
                        <span class="timeline-event-time mr-1">{{customFormatDateTime(item.created_at)}}</span>
                      </div>
                      <div class="col-12">
                        <hr  />
                      </div>
                      <p><strong>IP Address:</strong> {{item.ip}}</p>
                      <p v-if="item.transaction_uuid"><strong>Transaction UUID:</strong> {{item.transaction_uuid}}</p>
                      <p v-if="item.payment_token"><strong>Payment Token:</strong> {{item.payment_token}}</p>
                      <div class="media align-items-center d-flex" v-if="!item.read && item.data &&  Object.keys(item.data).length != 0">
                        <button type="button" class="btn btn-warning waves-effect waves-float waves-light btn-sm" @click="read(index)">Read more</button>
                      </div>
                      <div v-if="item.read && item.data &&  Object.keys(item.data).length != 0 " class="row ">
                        <div class="col-md-6 col-6">
                          <div class="card border-warning badge-glow">
                            <div class="card-body">
                              <div class="row ">
                                <div class="col-12">
                                  <div v-for="(dataItem,dataIndex) in item.data" :key="dataIndex" class="form-group row">
                                    <div class="col-sm-3">
                                      <p class="text-dark font-weight-bolder">{{dataIndex}}</p>
                                    </div>
                                    <div class="col-sm-9">
                                      <div class="input-group">
                                        <p >{{dataItem}}</p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li class="timeline-item">
<!--                    <BIconClockFill  class="border-secondary badge-glow text-secondary timeline-point" />-->
                    <feather type="clock" class="border-secondary badge-glow text-secondary timeline-point"></feather>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>

export default {
  mounted() {
    this.uuid = this.$route.params.id
    this.getPaymentLinkAttemptData()
  },
  data() {
    return {
      breadcrumb: [
        {name: 'App'},
        {name: 'Payment Link'},
        {name: 'Attempts'},
        {name: 'Logs'},
      ],
      attemptData: [],
      uuid: '',
      firstMsg : '',
      firstIp : '',
      firstCreatedAt : '',
      firstUuid : '',
      firstPaymentToken : '',
      firstData : [],
      firstShow : false,
      logs:[]

    }
  },
  methods: {
    read(index){
      this.logs[index].read = true
      this.logs = JSON.parse(JSON.stringify(this.logs))
    },
    getPaymentLinkAttemptData(){
      this.attemptData = this.$store.getters.getByKey(
          "paymentLinkLogsData"
      ).row
      if(this.attemptData){
        this.firstMsg = this.attemptData.message
        this.firstIp = this.attemptData.ip
        this.firstCreatedAt = this.attemptData.created_at
        this.firstUuid = this.attemptData.transaction_uuid
        this.firstPaymentToken = this.attemptData.payment_token
        this.firstData = this.attemptData.data
        // this.logs = this.attemptData.logs
        if(this.attemptData.logs){

          this.attemptData.logs.forEach(eachFeature => {
            eachFeature.read = false
            this.logs.push(eachFeature)
          })


        }

        console.log(this.attemptData.logs,'aaaaaaaaaaaaaaaaaaaa')


      }
    }

  },

}
</script>


